/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
/** RTK Query */
import {
  useAddUpdateOrganizationMailConfigMutation,
  useLazyGetOrgMailConfigByOrganizationIdQuery,
} from "../../../../app/services/organizationAPI";
/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/finalForms/FormCreator";
/** Common Services & Data Files */
import ToastService from "../../../../services/toastService/ToastService";
import { OrganizatonMailFormData } from "./config/OrganizationMail.data";

const OrganizationMailConfig = () => {
  const mailRef = useRef();
  /* State*/
  const [mailData, setMailData] = useState(OrganizatonMailFormData);
  const [organizatioinMailId, setOrganizatioinMailId] = useState(0);
  // API'S Call
  const [addUpdateOrganizationMailConfig, {
    isLoading: isAddEditOrganizationMailLoading,
    isSuccess: isAddEditOrganizationMailSuccess,
    data: isAddEditOrganizationMailData,
  },] = useAddUpdateOrganizationMailConfigMutation();

  const [getOrgMailConfigByOrganizationId, {
    isLoading: isGetOrganizationMailLoading,
    isFetching: isGetOrganizationMailFetching,
    isSuccess: isGetOrganizationMailSuccess,
    data: isGetOrganizationMailData,
  },] = useLazyGetOrgMailConfigByOrganizationIdQuery();

  const organizationId = useSelector((state) => state.auth.user?.organizationId);
  //** useEffect's */
  useEffect(() => {
    if (isAddEditOrganizationMailSuccess && isAddEditOrganizationMailData) {
      ToastService.success(isAddEditOrganizationMailData.errorMessage);
      getOrgMailConfigByOrganizationId(organizationId);
    }
  }, [isAddEditOrganizationMailSuccess, isAddEditOrganizationMailData]);

  useEffect(() => {
    getOrgMailConfigByOrganizationId(organizationId);
  }, [organizationId]);

  useEffect(() => {
    if (
      !isGetOrganizationMailFetching &&
      isGetOrganizationMailSuccess &&
      isGetOrganizationMailData
    ) {
      let formData = { ...mailData };
      formData.initialState = {
        organizationMailConfigId:
          isGetOrganizationMailData.organizationMailConfigId,
        organizationId: organizationId,
        smtpServer: isGetOrganizationMailData?.smtpServer,
        port: isGetOrganizationMailData?.port,
        emailSender: isGetOrganizationMailData?.emailSender,
        password: isGetOrganizationMailData?.password,
        useSSL: isGetOrganizationMailData?.useSSL,
      };
      setMailData(formData);
      setOrganizatioinMailId(
        isGetOrganizationMailData.organizationMailConfigId
      );
    }
  }, [
    isGetOrganizationMailFetching,
    isGetOrganizationMailSuccess,
    isGetOrganizationMailData,
  ]);
 //** Funcation's */
  const handleAddEditOrganizationMailDetail = () => {
    let data = mailRef.current.getFormData();
    if (data) {
      let request = {
        ...data,
        organizationId: data.organizationId,
        smtpServer: data?.smtpServer,
        port: data?.port,
        useSSL: data?.useSSL,
        password: data?.password,
        organizationMailConfigId: organizatioinMailId,
      };
      addUpdateOrganizationMailConfig(request);
    }
  };

  return (
    <div className="org-card-section">
      {/* <div className="org-card-section-title">Mail Config</div> */}
      <div isContentLoading={isGetOrganizationMailLoading || isAddEditOrganizationMailLoading}>
        <div className="org-card-section-body row">
          <FormCreator config={mailData} ref={mailRef} {...mailData} />
          <div className="col-md-12 mt-2">
            <div className="form-btn d-flex justify-content-end">
              <Buttons
                buttonTypeClassName="theme-btn ml-4"
                buttonText="Save"
                onClick={handleAddEditOrganizationMailDetail}
                isLoading={isAddEditOrganizationMailLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationMailConfig;
